import { Flo } from '../../types/flo-live-api'

export const isValidNumber = (n) => Number.isFinite(n) && n > 0

export const formatTime = (second: number) => {
  if (second === Infinity) {
    return '--:--:--'
  }

  const neg = second < 0 ? '-' : ''
  if (second < 0) {
    second = Math.abs(second)
  }

  const h = Math.floor(second / 3600)
  const m = Math.floor((second - h * 3600) / 60)
  const s = Math.floor(second - h * 3600 - m * 60)
  const mm = `${m}`.padStart(2, '0')
  const ss = `${s}`.padStart(2, '0')

  return `${neg}${h > 0 ? h + ':' : ''}${mm}:${ss}`
}

export const roundTo = (number, decimalPlace) => {
  const power = Math.pow(10, decimalPlace)
  return Math.round(number * power) / power
}

export const fullWidth = { w: (w) => w }
export const fullHeight = { h: (h) => h }
export const verticallyCentered = {
  mountY: 0.5,
  y: (h) => h / 2,
}
export const horizontallyCentered = {
  mountX: 0.5,
  x: (w) => w / 2,
}

export const appendQueryParams = (url: string, params: Record<string, string>): string => {
  const urlObj = new URL(url)
  Object.entries(params).forEach(([key, value]) => {
    urlObj.searchParams.append(key, value)
  })

  return urlObj.toString()
}

// Unified CDN: header-based bearer auth is preferred (attempt 0); ?token= is the
// documented fallback, used only when the header attempt failed (attempt 1).
export const getUnifiedCdnPlayback = (
  v2: Flo.Live.PremiumStreamResponse['v2'],
  attempt: 0 | 1,
): { url: string; headers?: Record<string, string> } => {
  if (attempt === 0) {
    return { url: v2.cleanUri, headers: { Authorization: `Bearer ${v2.jwt}` } }
  }

  return { url: `${v2.cleanUri}?token=${v2.jwt}` }
}
